import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as ErrorSvg } from "./assets/error.svg";
import styles from "./ToastErrorTile.module.styl";
import { Subtitle } from "uikit/components";

function ToastErrorTile({ error, title, text }) {
    if (error && error.response) {
        const status = error.response.status;
        if (status === 400) {
            title = "Ошибка 400";
            text = error.response.data.detail || "Невозможно выполнить запрос.";
        } else if (status === 403) {
            title = "Ошибка 403";
            text = "У вас недостаточно прав.";
        } else if (status === 422) {
            const data = error.response.data;
            title = data.title || "Ошибка";
            text = data.detail || "При обработке запроса произошла ошибка.";
        } else if (typeof status == "number") {
            title = `Ошибка ${status}`;
            text = "Возникла техническая ошибка. Попробуйте ещё раз.";
        }
    }

    title = title || `Ошибка`;
    text = text || "Возникла техническая ошибка. Попробуйте ещё раз.";

    return (
        <div className={styles.tile}>
            <div className={styles.icon}>
                <ErrorSvg />
            </div>
            <div className={styles.content}>
                <Subtitle size={"subtitle-1"}>{title}</Subtitle>
                <div className={styles.text}>{text}</div>
            </div>
        </div>
    );
}

ToastErrorTile.propTypes = {
    error: PropTypes.object,
    title: PropTypes.node,
    text: PropTypes.node,
};

export default ToastErrorTile;
